Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeTransport = void 0;
var utils_1 = require("@sentry/utils");
var wrapper_1 = require("../wrapper");
/** Native Transport class implementation */
var NativeTransport = /** @class */ (function () {
    function NativeTransport() {
        /** A simple buffer holding all requests. */
        this._buffer = new utils_1.PromiseBuffer(30);
    }
    /**
     * @inheritDoc
     */
    NativeTransport.prototype.sendEvent = function (event) {
        if (!this._buffer.isReady()) {
            return Promise.reject(new utils_1.SentryError('Not adding Promise due to buffer limit reached.'));
        }
        return this._buffer.add(function () { return wrapper_1.NATIVE.sendEvent(event); });
    };
    /**
     * @inheritDoc
     */
    NativeTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return NativeTransport;
}());
exports.NativeTransport = NativeTransport;
//# sourceMappingURL=native.js.map